import { Grid } from '@material-ui/core';
import {
  EntityAboutCard,
  EntityHasSubcomponentsCard,
  EntityLinksCard,
  EntitySwitch
} from '@backstage/plugin-catalog';
import { EntityCatalogGraphCard } from '@backstage/plugin-catalog-graph';
import { hasLinks } from './hasLinks';
import { defaultEntityWarningContent } from './EntityWarningContent';

export const minimumOverviewContent = () => (
  <Grid container spacing={3} alignItems="stretch">
    {defaultEntityWarningContent}
    <Grid item md={6}>
      <EntityAboutCard />
    </Grid>
    <Grid item md={6} xs={12}>
      <EntityCatalogGraphCard height={400} />
    </Grid>

    <EntitySwitch>
      <EntitySwitch.Case if={hasLinks}>
        <Grid item xs={12} md={6}>
          <EntityLinksCard />
        </Grid>
      </EntitySwitch.Case>
    </EntitySwitch>

    <Grid item md={12} lg={6}>
      <EntityHasSubcomponentsCard />
    </Grid>
  </Grid>
);
